import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { useTheme } from '../../contexts/ThemeContext';

const EChartLiftCurv = ({ data }) => {
    const chartRef = useRef(null);
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    useEffect(() => {
        if (!data || data.length === 0) return;

        const chart = echarts.init(chartRef.current);
        const axisColor = isDark ? '#ccc' : '#333';
        const option = {
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                borderColor: '#a0aec0',
                borderWidth: 1,
                textStyle: {
                    color: axisColor
                }
            },
            legend: {
                data: ['Lift (Total Sales)', 'Cumulative Lift'],
                textStyle: { fontSize: 12, color: axisColor },
            },
            grid: {
                left: '10%',
                right: '10%',
                bottom: '10%',
                top: '10%'
            },
            xAxis: {
                type: 'category',
                name: 'Decile',
                nameLocation: 'end',
                nameGap: 20,
                data: data.map(item => item.index),
                axisLine: {
                    lineStyle: {
                        color: '#a0aec0'
                    }
                },
                axisLabel: {
                    color: axisColor
                }
            },
            yAxis: {
                type: 'value',
                name: 'Lift',
                nameRotate: 90,
                nameGap: 40,
                axisLine: {
                    lineStyle: {
                        color: '#a0aec0'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#a0aec0',
                        type: 'dashed'
                    }
                },
                axisLabel: {
                    color: axisColor
                }
            },
            series: [
                {
                    name: 'Lift (Total Sales)',
                    type: 'line',
                    smooth: true,
                    data: data.map(item => item['Lift (Total Sales)']),
                    lineStyle: {
                        color: '#4A90E2'
                    },
                    itemStyle: {
                        color: '#4A90E2'
                    }
                },
                {
                    name: 'Cumulative Lift',
                    type: 'line',
                    smooth: true,
                    data: data.map(item => item['Cumulative Lift']),
                    lineStyle: {
                        color: '#50E3C2'
                    },
                    itemStyle: {
                        color: '#50E3C2'
                    }
                }
            ]
        };

        chart.setOption(option);

        const resizeObserver = new ResizeObserver(() => chart.resize());
        resizeObserver.observe(chartRef.current);

        return () => {
            resizeObserver.disconnect();
            chart.dispose();
        };
    }, [data]);

    if (!data || data.length === 0) {
        return <p className="text-sm text-gray-500 dark:text-gray-400">Lift curve data not available.</p>;
    }

    return <div ref={chartRef} style={{ width: '100%', height: '300px' }} />;
};

export default EChartLiftCurv;
